import React from 'react'
import TopBar from '../Home/Mainhomeone/Topbar'
import Header from '../Globle/Header1'
import Navigation from '../Home/Mainhomeone/Navigation'
import SmallScreenNav from '../Home/Mainhomeone/SmallScreenNav'
import Breadcrumb from '../Globle/Breadecrumb'
import Portfolio from '../Mainportfolio/Portfolio'
import Footer1 from '../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <SmallScreenNav />
            <Breadcrumb title='Portfolio' />
            <Portfolio />
            <Footer1 />
        </>
    )
}

export default Main
